/* eslint-disable */
import React, { useState, useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import Alert from 'react-s-alert';
import Select from 'react-select';
import { getJson } from 'session';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import Drawer from '@material-ui/core/Drawer';
import { withStyles } from '@material-ui/core/styles';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import { Acl } from 'modules/common/components/Acl';
import ExportHistoryModal from '../modals/ExportHistoryModal';
import Pagination from 'modules/common/components/Pagination';

import * as actions from '../../actions';
import * as c from '../../constant';
import ViewTransactionLogDetailModal from '../modals/ViewTransactionLogDetailModal';

const styles = () => ({
  dialogPaper: {
    width: '100%',
    maxWidth: '400px',
  },
});

const TransactionLog = ({
  isGenerating,
  history,
  generateTransactionalAuditLogReports,
  isLoading,
  getTransactionalReportList,
  reportList,
  classes,
  pager,
  module,
}) => {
  const [showSide, setShowSide] = useState(false);
  const setModal = useContext(ModalContext);
  const permissions = getJson('permissions');

  const [formData, setFormData] = useState({
    date_from: `${moment(new Date()).subtract(1, 'days').format('MM/DD/YYYY')}`,
    date_to: `${moment(new Date()).format('MM/DD/YYYY')}`,
  });

  useEffect(() => {
    const datedToday = {
      module: module,
      date_from: `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}`,
      date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
    };

    setFormData({
      ...formData,
      q: '',
      event: '',
      user_type: '',
    });

    getTransactionalReportList(datedToday);
  }, [module]);

  const handleDateChange =
    (key) =>
    ({ target: { value } }) => {
      if (
        key === 'date_from' &&
        `${moment(new Date(value)).format('yyyy-MM-DD')}` >
          `${moment(new Date(_.get(formData, 'date_to'))).format('yyyy-MM-DD')}`
      ) {
        Alert.warning('Invalid filter, Date From is greater than Date To');

        setFormData({
          ...formData,
          [key]: '',
        });
        return;
      }

      setFormData({
        ...formData,
        [key]: value,
      });
    };

  const handleChangeSelect = (key) => (e) => {
    setFormData({
      ...formData,
      [key]: _.get(e, 'value', '') || '',
    });
  };

  const handleSearch = (e) => {
    e.preventDefault();

    let payload = {
      q: _.get(formData, 'q', ''),
      module: module,
      date_from: moment(_.get(formData, 'date_from'))
        .subtract(1)
        .format('yyyy-MM-DD'),
      date_to: moment(_.get(formData, 'date_to')).format('yyyy-MM-DD'),
      event: _.get(formData, 'event', ''),
      user_type: _.get(formData, 'user_type', ''),
    };

    getTransactionalReportList(_.omitBy(payload, _.isEmpty));
  };

  const onClear = (e) => {
    e.preventDefault();
    setFormData({
      q: '',
      module: module,
      date_from: `${moment(new Date())
        .subtract(1, 'days')
        .format('MM/DD/YYYY')}`,
      date_to: `${moment(new Date()).format('MM/DD/YYYY')}`,
      event: '',
      user_type: '',
    });
  };

  const handlePreview = (item) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <PreviewModal
          // data={item}
          id={item.id}
        />
      ),
      title: `Distribution Report by Revenue Account`,
      modalSize: 'modal-xl',
    });
  };

  const handleExportHistory = () => (e) => {
    e.preventDefault();

    let payload = {
      ...formData,
      module: module,
      date_from: moment(_.get(formData, 'date_from'))
        .subtract(1)
        .format('yyyy-MM-DD'),
      date_to: moment(_.get(formData, 'date_to')).format('yyyy-MM-DD'),
    };

    generateTransactionalAuditLogReports(
      _.omitBy(payload, _.isEmpty),
      (data) => {
        Alert.success('Export Success');

        const payload = { module: module };
        history.push('/audits/export', { payload });
      }
    );
  };

  const handleViewDetail = (item) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ViewTransactionLogDetailModal data={item} />,
      title: `View Details`,
      modalSize: 'modal-xl',
    });
  };

  const handleClose = () => {
    setShowSide(false);
  };

  const handleChangePage = (page) => {
    const args = {
      ...formData,
      date_from: `${moment(_.get(formData, 'date_from')).format('YYYY-MM-DD')}`,
      date_to: `${moment(_.get(formData, 'date_to')).format('YYYY-MM-DD')}`,
      type: 'BPLS',
      page,
    };

    getTransactionalReportList(args);
  };

  const onChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const exportPermissionsMap = {
    BPLS_AUDIT: 'EXPORT BPLS AUDITS',
    BIRTH_CERTIFICATE_AUDIT: 'EXPORT BIRTH CERTIFICATE AUDITS',
    DEATH_CERTIFICATE_AUDIT: 'EXPORT DEATH CERTIFICATE AUDITS',
    MARRIAGE_CERTIFICATE_AUDIT: 'EXPORT MARRIAGE CERTIFICATE AUDITS',
    CEDULA_AUDIT: 'EXPORT CEDULA AUDITS',
  };

  const requiredPermission = exportPermissionsMap[module];

  return (
    <>
      <div className="" style={{ width: '100%' }}>
        <form onSubmit={handleSearch} className="mb-3">
          {Acl(permissions, [requiredPermission]) && (
            <div className="form-input-group" style={{ width: '99.5%' }}>
              <div
                className="full-input"
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'flex-end',
                }}
              >
                <button
                  style={{ paddingTop: '0px', marginTop: '0px' }}
                  onClick={handleExportHistory()} // Note: Removed the parentheses
                  className="btn btn-primary cms-bg-color-primary font-weight-bold button-distribution-report"
                  type="button"
                >
                  <i
                    className={
                      isGenerating
                        ? 'fas fa-1x fa-spin fa-spinner mr-1'
                        : 'fas fa-download mr-2'
                    }
                  />{' '}
                  Export
                </button>
              </div>
            </div>
          )}

          <div className="d-flex">
            <div
              className="form-input-group ml-2"
              style={{ width: '170px', marginRight: '7px', width: '220px' }}
            >
              <div className="form-group">
                <label className="label-reports">Keyword</label>
                <input
                  placeholder="keyword"
                  className="form-control"
                  name="q"
                  value={_.get(formData, 'q') || ''}
                  onChange={onChange}
                />
              </div>
            </div>
            <div className="form-input-group" style={{ width: '170px' }}>
              <label className="label-reports">Date From</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_from')}
                value={_.get(formData, 'date_from') || ''}
                maxDate={new Date(_.get(formData, 'date_to'))}
                endDate={new Date(_.get(formData, 'date_to'))}
              />
            </div>
            <div className="form-input-group ml-2" style={{ width: '170px' }}>
              <label className="label-reports">Date To</label>
              <DateInputPicker
                className="full-input"
                style={{ height: '36px' }}
                onChange={handleDateChange('date_to')}
                value={_.get(formData, 'date_to') || ''}
                minDate={new Date(_.get(formData, 'date_from'))}
              />
            </div>
            <div className="form-input-group ml-2" style={{ width: '170px' }}>
              <div className="form-group">
                <label className="label-reports">Event Type</label>
                <Select
                  isClearable
                  name="event"
                  placeholder="Select Event"
                  onChange={handleChangeSelect('event')}
                  options={
                    module === 'BPLS_AUDIT'
                      ? c.BPLS_EVENTS
                      : module == 'CEDULA_AUDIT'
                      ? c.CEDULA_EVENTS
                      : c.LCR_EVENTS
                  }
                  value={
                    (module === 'BPLS_AUDIT'
                      ? c.BPLS_EVENTS
                      : module == 'CEDULA_AUDIT'
                      ? c.CEDULA_EVENTS
                      : c.LCR_EVENTS
                    ).find((option) => option.value === formData.event) || null
                  }
                />
              </div>
            </div>

            <div className="form-input-group ml-2" style={{ width: '170px' }}>
              <div className="form-group">
                <label className="label-reports">User Type</label>
                <Select
                  isClearable
                  name="user_type"
                  placeholder="Select User Type"
                  onChange={handleChangeSelect('user_type')}
                  options={c.USER_TYPES}
                  value={
                    c.USER_TYPES.find(
                      (option) => option.value === formData.user_type
                    ) || null
                  }
                />
              </div>
            </div>
            <div className="form-input-group ml-2">
              <div className="full-input">
                <button
                  disabled={
                    _.isEmpty(_.get(formData, 'date_from')) ||
                    _.isEmpty(_.get(formData, 'date_to'))
                  }
                  type="submit"
                  className="btn btn-primary cms-bg-color-primary text-white button-distribution-report mr-2"
                >
                  <i className="fas fa-search" /> &nbsp;&nbsp;Search
                </button>
                <button
                  onClick={onClear}
                  type="submit"
                  className="btn btn-primary cms-bg-color-primary text-white button-distribution-report mr-2"
                >
                  <i className="fas fa-times" /> &nbsp;&nbsp; Clear
                </button>
              </div>

              {/* <button
                  onClick={onClear}
                  type="button"
                  className="btn btn-link button-clear cms-bg-color-primary cms-outline-primary ml-2"
                >
                  <i className="fas fa-times" /> &nbsp;&nbsp; Clear
                </button> */}
            </div>
          </div>
        </form>
        {isLoading ? (
          <div
            className="loading d-flex text-center justify-content-center align-items-center"
            style={{ height: '500px' }}
          >
            <div className="spinner text-center ">
              <span className="fas fa-5x fa-spin fa-spinner" />
            </div>
          </div>
        ) : (
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              // padding: "10px",
              marginBottom: '20px',
            }}
          >
            <div className="mb-3">
              {reportList.length > 0 ? (
                <div className="mt-2 table-responsive">
                  <table className="table table-striped table-sm table-bordered table-hover">
                    <thead className="table-header">
                      <tr className="billing-table-tr">
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          DATE AND TIME
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          USER NAME
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          USER TYPE
                        </th>
                        {module == 'BPLS_AUDIT' && (
                          <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                            SUBJECT TYPE
                          </th>
                        )}
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          EVENT TYPE
                        </th>
                        <th className="py-3 cms-text-primary cms-bg-color-primary-light align-middle">
                          ACTION
                        </th>
                      </tr>
                    </thead>
                    <tbody className="table-details">
                      {reportList.map((item, index) => {
                        return (
                          <tr className="billing-table-tr" key={index}>
                            <td>{_.get(item, 'created_at') || '---'}</td>
                            <td>{_.get(item, 'user_name') || '---'}</td>
                            <td>{_.get(item, 'user_type') || '---'}</td>
                            {module == 'BPLS_AUDIT' && (
                              <td>{_.get(item, 'subject_type') || '---'}</td>
                            )}
                            <td>{_.get(item, 'event') || '---'}</td>
                            <td style={{ width: '100px' }}>
                              <button
                                onClick={handleViewDetail(item)}
                                className="btn btn-primary cms-bg-color-primary font-weight-bold button-distribution-report"
                                style={{ marginTop: '0px' }}
                                type="button"
                              >
                                View Details
                              </button>
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="d-flex align-items-center justify-content-center h-100">
                  <div className="text-center mx-auto py-4">
                    <img
                      src={emptyStateImage}
                      className="img-responsive image-wrapper mb-4 mt-3"
                      alt="Empty State"
                    />
                    <p className="emp-title mb-0">No Item Found</p>
                  </div>
                </div>
              )}
            </div>
            <div className="list-pagination">
              {pager.total_pages > 1 && (
                <div className="d-flex justify-content-center text-center align-item-center">
                  <Pagination data={pager} onChange={handleChangePage} />
                </div>
              )}
            </div>
          </div>
        )}
      </div>
      <Drawer
        PaperProps={{ classes: { root: classes.dialogPaper } }}
        anchor="right"
        open={showSide}
        onClose={handleClose}
        style={{ width: '100%', maxWidth: '400px' }}
      >
        <ExportHistoryModal handleClose={handleClose} />
      </Drawer>
    </>
  );
};

TransactionLog.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  getTransactionalReportList: PropTypes.instanceOf(Function).isRequired,
  generateTransactionalAuditLogReports:
    PropTypes.instanceOf(Function).isRequired,
  reportList: PropTypes.instanceOf(Array).isRequired,
  classes: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  reportList: _.get(api, `${c.GET_TRANSACTIONAL_REPORT_LIST}.list`) || [],
  pager: _.get(api, `${c.GET_TRANSACTIONAL_REPORT_LIST}.pager`) || {},
  isLoading:
    _.get(api, 'loading', []).indexOf(c.GET_TRANSACTIONAL_REPORT_LIST) > -1,
  isGenerating:
    _.get(api, 'loading', []).indexOf(c.GENERATE_TRANSACTIONAL_AUDIT_LOG) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default withStyles(styles)(enhance(TransactionLog));
